import PropTypes from 'prop-types';
import React from 'react';

const NeedHelpFooter = ({ isEducationRelated = false }) => {
  return (
    <va-need-help>
      <div slot="content">
        <p>
          Call us at{' '}
          <va-telephone
            contact={isEducationRelated ? '8884424551' : '8008271000'}
          />{' '}
          (<va-telephone contact="711" tty="true" />
          ). We’re here Monday through Friday, 8:00 a.m to{' '}
          {isEducationRelated ? '7:00' : '9:00'} p.m ET.
        </p>
        {isEducationRelated && (
          <p>
            For students outside the U.S., call us at{' '}
            <va-telephone contact="9187815678" international />.
          </p>
        )}
      </div>
    </va-need-help>
  );
};

NeedHelpFooter.propTypes = {
  isEducationRelated: PropTypes.bool,
};

export default NeedHelpFooter;
